'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';

export function JoinGuestForm() {
  const router = useRouter();
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const v = value.trim();
    if (!v) return;
    let roomId = v;
    try {
      const u = new URL(v);
      const parts = u.pathname.split('/').filter(Boolean);
      if (parts[0] === 'rooms' && parts[1]) roomId = parts[1];
    } catch {
      // not a URL
    }
    if (!roomId) return;
    setLoading(true);
    router.push(`/rooms/${roomId}`);
  };

  return (
    <form className="wz-guest-form" onSubmit={onSubmit}>
      <input
        className="wz-input"
        placeholder="Paste meeting link or room ID"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={loading}
      />
      <button type="submit" className="wz-btn wz-btn-ghost" disabled={loading || !value.trim()}>
        {loading ? <Spinner /> : 'Join →'}
      </button>
    </form>
  );
}

function Spinner() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" className="wz-icon-spin" fill="none">
      <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
      <path d="M12.5 7a5.5 5.5 0 0 0-5.5-5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
